<template>
  <modal show="true" @close="$emit('close')" :transparent="true">
    <on-click-outside @outside="$emit('close')">
      <div class="modal-form card">
        <div class="flex justify-between items-center bb b--near-white pb2">
          <h1 class="lh-title text-primary f6 ma0 pa0 ttu">Новое письмо</h1>
          <button class="input-icon-button bg-light ml3" @click="$emit('close')">
            <font-awesome-icon icon="times" />
          </button>
        </div>
        <div class="fields mv3">
          <span class="label input-label required">Кому</span>
          <email-input v-model="recipients" :suggestions="value.suggestions"/>
          <span class="label input-label">Копия</span>
          <email-input v-model="ccRecipients" :suggestions="value.suggestions"/>
          <span class="label input-label required">Тема</span>
          <input type="text" placeholder="тема" class="text-input bg-middle" v-model="subject"/>
          <span class="label input-label required">Письмо</span>
          <textarea type="text" rows="10" class="bg-middle " placeholder="текст письма" v-model="content"></textarea>
          <span class="label input-label">Файлы</span>
          <ul class="list ma0 pa0 files">
            <li v-for="(file, index) in files" :key="index" class="file">
              <font-awesome-icon icon="paperclip" class="text-accent"/>
              <span class="ml2">
                {{ file.title }}
              </span>
            </li>
          </ul>
        </div>

        <alert :visible="error" type="error" @dismiss="error = false" class="mv2">
          :( Ошибка отправки письма. Пожалуйста, подождите и попробуйте еще раз.
        </alert>

        <div class="bt b--near-white pt3 flex justify-end">
          <send-button title="Отправить" :loading="sending" :disabled="!formValid" @click="sendEmail" />
        </div>
      </div>
    </on-click-outside>
  </modal>
</template>

<script>
import Modal from '@/components/modal/Modal.vue'
import OnClickOutside from '@/components/ui/OnClickOutside.vue'
import EmailInput from './Input.vue'
import SendButton from '@/components/ui/Button.vue'
import Alert from '@/components/ui/Alert.vue'

export default {
  props: {
    show: { default: false },
    send: { type: Function },
    value: {
      default: () => {
        return {
          suggestions: [],
          recipients: [],
          ccRecipients: [],
          subject: null,
          text: null,
          files: []
        }
      }
    }
  },
  components: {
    Modal,
    OnClickOutside,
    EmailInput,
    SendButton,
    Alert
  },
  computed: {
    recipients: {
      get () { return this.value.recipients },
      set (recipients) { this.$emit('input', { ...this.value, recipients }) }
    },
    ccRecipients: {
      get () { return this.value.ccRecipients },
      set (ccRecipients) { this.$emit('input', { ...this.value, ccRecipients }) }
    },
    subject: {
      get () { return this.value.subject },
      set (subject) { this.$emit('input', { ...this.value, subject }) }
    },
    content: {
      get () { return this.value.content },
      set (content) { this.$emit('input', { ...this.value, content }) }
    },
    files: {
      get () { return this.value.files },
      set (files) { this.$emit('input', { ...this.value, files }) }
    },
    formValid () {
      return this.recipients && this.recipients.length > 0 &&
        this.subject && this.subject.trim() &&
        this.content && this.content.trim()
    }
  },
  data () {
    return {
      showModal: false,
      sending: false,
      error: false
    }
  },
  methods: {
    sendEmail () {
      this.sending = true
      this.send()
        .then((r) => {
          this.$emit('close')
        })
        .catch((e) => {
          this.error = true
        })
        .finally(() => {
          this.sending = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.files {
  max-height: 10rem;
  overflow-y: scroll;
  .file {
    margin-top: .6rem;
    &:not(:last-child) {
      margin-bottom: .5rem;
    }
  }
}
</style>
